<template>
  <div class="tabs pl-2">
    <template v-for="view in views">
      <div
        class="tab px-2"
        :key="view"
        @click="handleChangeView(view)"
        :class="{ active: view == currentView }"
        :style="{
          'background-color': view == currentView ? $vuetify.theme.primary : 'transparent',
          cursor: 'pointer'
        }"
        v-if="(view == 'report' && input && input.is_draft == false) || view != 'report'"
      >
        {{ view }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['value', 'input'],
  data() {
    return {
      views: ['general', 'condition', 'privilege', 'reward', 'report'],
      currentView: 'general'
    }
  },
  mounted() {
    this.currentView = this.value
  },
  methods: {
    handleChangeView(view) {
      this.$emit('handleChangeView', view)
    }
  }
}
</script>

<style lang="scss" scoped>
#generali {
  .tabs {
    .tab {
      // cursor: pointer;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      &.active {
        color: white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/GameSetting/GameSettingTab.vue